import { RouteType } from "../../../types/RouteType";

const qcManagerDashboardRoute: RouteType = {
  name: "QC Manager Dashboard",
  path: "/qc/manager",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./QCManagerDashboard.Header"),
      title: "QC Manager Dashboard",
      color: "primary",
      enableRefreshButton: true,
    },
    body: {
      component: () => import("./QCManagerDashboard.Body"),
      grayBackground: true,
    },
  },
  group: "Quality Control",
  requiresAuth: true,
  requiresPermission: false, // TODO: Add 'qc:manager' permission check

  beforeEnter: async ({ rootStore }) => {
    try {
      const store = rootStore.qcManagerDashboardStore;
      if (store && typeof store === "object" && "loadDashboardData" in store) {
        await (store as any).loadDashboardData();
      }
      return true;
    } catch (error) {
      console.error("Failed to load QC Manager Dashboard:", error);
      return false;
    }
  },

  onExit: ({ rootStore }) => {
    const store = rootStore.qcManagerDashboardStore;
    if (store && typeof store === "object" && "reset" in store) {
      (store as any).reset();
    }
  },

  dialogs: [],
};

export default qcManagerDashboardRoute;
